import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GPlanService } from '../_services/gplan-service/gplan.service';
import { ChangeDetectorRef } from '@angular/core';
import { ConfigurationService } from '../_services/configuration/configuration.service';
import { DateUtils } from '../_commons/date-utils';

interface Scenario{
  scenarioName: string;
  scenarioId: number;
  scenarioIntervalStart: string;
  scenarioIntervalEnd: string;
  scenarioCalculatedTimeIntervals: number;
  numberOfVoltageViolation: number;
  numberOfLineLoadingViolation: number;
  numberOfNodeLoadingViolation: number;
  minVoltage: number;
  maxVoltage: number;
  maxCableLoad: number;
  maxNodeLoad: number;
}

@Component({
  selector: 'app-gplan-summary-table',
  templateUrl: './gplan-summary-table.component.html',
  styleUrls: ['./gplan-summary-table.component.css']
})
export class GplanSummaryTableComponent implements OnInit {

  // alreadyCheckedScenariosID: Array<number> = new Array<number>();
  constructor(
    public activeModal: NgbActiveModal,
    private gplanService: GPlanService,
    private configurationService: ConfigurationService
  ) {
    this.parameterForCalculatingTimeIntervalsForTheScenario = this.configurationService.getConfiguration().parameterForCalculatingTimeIntervalsForTheScenario
  }

  scenarios: Scenario[]= []
  private parameterForCalculatingTimeIntervalsForTheScenario: number;

  ngOnInit(){
    this.gplanService.sharedSelectedScenarioID$.subscribe((infoAboutScenario) => {

        //calcultaing the time intervals (for 15 minutes)
        const intervalStartInTime = new Date(infoAboutScenario.scenarioIntervalStart);
        const intervalEndInTime = new Date(infoAboutScenario.scenarioIntervalEnd);

        const calculatedDifferenceInMilliseconds = (intervalEndInTime.getTime() - intervalStartInTime.getTime()) /( this.parameterForCalculatingTimeIntervalsForTheScenario * 60 * 1000) ;

        //saving the response and the info about the scenario into the interface

        let inCaseOfWCIntervalStart: string = "-";
        let inCaseOfWCIntervalEnd: string = "-";
        let inCaseOfWCCalculatedTimeIntervals: number = 1;
        this.gplanService.getGPSummaryInfo(infoAboutScenario.scenarioId).subscribe((response: any) =>{
          if(infoAboutScenario.scenarioType == "WC"){
            this.scenarios = [
              {
                scenarioName: infoAboutScenario.scenarioName,
                scenarioId: infoAboutScenario.scenarioId,
                scenarioIntervalStart: inCaseOfWCIntervalStart,
                scenarioIntervalEnd: inCaseOfWCIntervalEnd,
                scenarioCalculatedTimeIntervals: inCaseOfWCCalculatedTimeIntervals,
                numberOfVoltageViolation: response.numberOfVoltageViolation,
                numberOfLineLoadingViolation: response.numberOfLineLoadingViolation,
                numberOfNodeLoadingViolation: response.numberOfNodeLoadingViolation,
                minVoltage: response.minVoltage,
                maxVoltage: response.maxVoltage,
                maxCableLoad: response.maxCableLoad,
                maxNodeLoad: response.maxNodeLoad
              }
            ]
          }else{
            this.scenarios = [
              {
                scenarioName: infoAboutScenario.scenarioName,
                scenarioId: infoAboutScenario.scenarioId,
                scenarioIntervalStart: DateUtils.stringUTCDateToLocalDate(infoAboutScenario.scenarioIntervalStart),
                scenarioIntervalEnd: DateUtils.stringUTCDateToLocalDate(infoAboutScenario.scenarioIntervalEnd),
                scenarioCalculatedTimeIntervals: calculatedDifferenceInMilliseconds,
                numberOfVoltageViolation: response.numberOfVoltageViolation,
                numberOfLineLoadingViolation: response.numberOfLineLoadingViolation,
                numberOfNodeLoadingViolation: response.numberOfNodeLoadingViolation,
                minVoltage: response.minVoltage,
                maxVoltage: response.maxVoltage,
                maxCableLoad: response.maxCableLoad,
                maxNodeLoad: response.maxNodeLoad
              }
            ]
          }
        });
    });

  }

  getColoringData(scenario: Scenario): string{
    if(scenario.numberOfVoltageViolation > 0 || scenario.numberOfLineLoadingViolation > 0 || scenario.numberOfNodeLoadingViolation > 0){
      return "red";
    }
  }

}
